import {
  ImagePreviewStrip,
  type ImageAttachment,
} from "@/components/panels/image-preview-strip";

export function CommentPopoverImages({
  images,
  onRemove,
}: {
  images: ImageAttachment[];
  onRemove: (imageId: string) => void;
}) {
  return (
    <ImagePreviewStrip
      inset
      className="mt-1"
      images={images}
      onRemove={onRemove}
    />
  );
}
